import VisibilityModal from './visibility-modal';

export default VisibilityModal;
